import { render, staticRenderFns } from "./create-tags-helper.vue?vue&type=template&id=1e8b0046&scoped=true&lang=html&"
import script from "./create-tags-helper.vue?vue&type=script&lang=js&"
export * from "./create-tags-helper.vue?vue&type=script&lang=js&"
import style0 from "./create-tags-helper.vue?vue&type=style&index=0&id=1e8b0046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b0046",
  null
  
)

component.options.__file = "create-tags-helper.vue"
export default component.exports